import React from "react";
import { Button, InputGroup, Typography } from "@icecreamsocial/components";
import { useIntl } from "react-intl";
import { Checkbox } from "@material-ui/core";
import { useAtom } from "jotai";
import { requiredConsentAtom } from "../../../../shared/atoms";
import { ConsentEditButton } from "../ConsentEditButton";

export const PhoneNumberConsentCheckbox = ({ formik, ctx, ...props }) => {
  const [requireConsent] = useAtom(requiredConsentAtom);
  const intl = useIntl();
  const CONTACT_CONSENT_PHONE = intl.formatMessage(
    {
      id: "contact.consent.phone",
      defaultMessage: "Text updates to <underlined>{phoneNumber}</underlined>",
      description:
        "Label for checkbox to allow ICS to send sms to the provided phone number"
    },
    {
      underlined: str => (
        <Typography.Span textDecoration="underline">{str}</Typography.Span>
      ),
      phoneNumber: formik.values.mobileNumber
    }
  );

  const CONTACT_CONSENT_PHONE_HINT = intl.formatMessage(
    {
      id: "contact.consent.hint.phone",
      defaultMessage: "Text updates to {phoneNumber}",
      description:
        "A popover hint equivalent for contact.consent.phone.  This only shows on hover in case the text is cutoff.  This needs to be plaintext so we cannot reuse the contact.consent.phone translation"
    },
    {
      phoneNumber: formik.values.mobileNumber
    }
  );

  return formik.values.mobileNumber ? (
    <InputGroup {...props}>
      <Checkbox
        name="smsConsent"
        color="primary"
        value={formik.values.smsConsent}
        checked={formik.values.smsConsent === true}
        onClick={formik.handleChange}
        required={requireConsent.sms}
      />
      <InputGroup.Label
        title={CONTACT_CONSENT_PHONE_HINT}
        overflow="hidden"
        style={{ textOverflow: "ellipsis" }}
      >
        {CONTACT_CONSENT_PHONE}
      </InputGroup.Label>
      <ConsentEditButton onClick={() => ctx.back(formik.values)} />
    </InputGroup>
  ) : null;
};
